import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { updateCheckedOptionalsbySubLot, getcheckedOptionalsBySubLotId } from '../../../../store/actions/carOptionals/carOptionalsActions';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Tooltip from '@material-ui/core/Tooltip';
import Divider from '@material-ui/core/Divider';
import Paper from '@material-ui/core/Paper';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import OptionalsIcon from '@material-ui/icons/Settings';
import CheckIcon from '@material-ui/icons/Check';
import SearchIcon from '@material-ui/icons/Search';
import OptionalsAPI from '../../../../API/OptionalsAPI';
import SnackbarAlert from '../../../Utils/SnackbarAlert';
import LinearProgress from '../../../Utils/LinearProgress';
import AdminOptionalsModal from '../../../Administration/AdminOptionals/AdminOptionalsModal';
import { handleServerError, handleSpecialCharacters } from '../../../../Utils/Helper';
import { UR_CREATION_GROUP, NEGOTIATION_PHASE, UR_PHASE } from '../../../../Utils/Constants';


const styles = theme => ({
  marginSelectOptionals: {
    margin: '12px 0px 8px 0px'
  },
  toolbarRoot: {
    display: 'flex',
    position: 'relative',
    backgroundColor: theme.palette.primary[500],
    padding: '0px 12px'
  },
  titleHead: {
    color: '#ffffff'
  },
  searchField: {
    width: '400px',
    margin: '4px 0px 8px 0px'
  },
  searchIconMargin: {
    marginRight: '4px'
  },
  checboxSize: {
    width: '32px',
    height: '32px'
  },
  button: {
    margin: theme.spacing.unit
  },
  buttonSize: {
    width: '36px',
    height: '36px'
  }
});


class RUOptionals extends React.Component {
  searchTimer = null;

  constructor(props) {
    super(props);
    this.state = {
      openOptionals: false,
      scroll: 'paper',
      loadingOptionals: false,
      openError: false,
      alertMessage: '',
      searchOptionalsBy: '',
      reloading: false,
      negOptionals: 'neg',
      optionalsData: []
    };
  }

  handleClickOpen = scroll => () => {
    this.setState({
      openOptionals: true,
      optionalsData: this.props.optionalsData,
      scroll
    });
  };

  handleCloseOptionals = () => {
    this.setState({
      searchOptionalsBy: '',
      openOptionals: false
    });
  };

  handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({
      openError: false,
      alertMessage: ''
    });
  };

  handleCheckboxChange = name => event => {
    this.props.updateCheckedOptionalsbySubLot(this.props.subLotId, name, event.target.checked);
    this.props.detectChange();
  };

  handleSearch = event => {
    this.setState({ searchOptionalsBy: handleSpecialCharacters(event.target.value) });
    this.reloadOptionalsBySearch();
  };

  reloadOptionalsBySearch() {
    const optionalsDataAPI = new OptionalsAPI();
    this.setState({ reloading: true });
    clearTimeout(this.searchTimer);
    this.searchTimer = setTimeout(() => {
      optionalsDataAPI.getAllOptionals(this.state.searchOptionalsBy).then((response) => {
        this.setState({
          optionalsData: response.data,
          reloading: false
        });
      }).catch((error) => {
        this.setState({
          reloading: false,
          openError: true,
          alertMessage: handleServerError(error)
        })
      });
    }, 1500);
  };

  renderNegOptionals(optionalsList) {
    const { selectedOptionals, classes } = this.props;

    let optionalsFiltered = optionalsList.filter((oItem) => {
      return !(oItem.Deleted)
    });

    let aOptionalsCheckbox = optionalsFiltered.map(optionalsListItem => {

      return (
        <Grid item xs={12} sm={6} key={optionalsListItem.value} checked={(selectedOptionals.indexOf(optionalsListItem.value) !== -1)} >
          {this.props.estadoId === UR_PHASE ?
            <FormControlLabel
              control={
                <Checkbox
                  className={classes.checboxSize}
                  checked={selectedOptionals.indexOf(optionalsListItem.value) !== -1}
                  value={this.props.optionalsListItem}
                  color='secondary'
                />
              }
              label={optionalsListItem.label}
            /> :
            <FormControlLabel
              control={
                <Checkbox
                  className={classes.checboxSize}
                  checked={selectedOptionals.indexOf(optionalsListItem.value) !== -1} // using arrays is not as good as using key maps, but for now time is an issue
                  value={this.props.optionalsListItem}
                  onChange={this.handleCheckboxChange(optionalsListItem.value)}
                  color='primary'
                />
              }
              label={optionalsListItem.label}
            />
          }
        </Grid>
      );
    });
    //sorts the checked ones first
    return aOptionalsCheckbox.sort((x, y) => {
      return (x.props.checked === y.props.checked) ? 0 : x.props.checked ? -1 : 1;
    });
  }


  render() {
    const { classes } = this.props;
    const { reloading } = this.state;

    return (
      <span>

        <Tooltip title='Alterar Opcionais' placement='bottom' >
          <Button disabled={this.props.estadoId !== NEGOTIATION_PHASE || this.props.user.UserRoleType.indexOf(UR_CREATION_GROUP) < 0} variant='fab' color='primary' onClick={this.handleClickOpen('paper')} className={classNames(classes.button, classes.buttonSize)}>
            <OptionalsIcon />
          </Button>
        </Tooltip>

        <Dialog
          fullWidth
          maxWidth='md'
          open={this.state.openOptionals}
          onClose={this.handleCloseOptionals}
          scroll={this.state.scroll}
        >
          <Paper>
            <Toolbar className={classes.toolbarRoot}>
              <Grid container alignItems='center'>
                <Grid item xs={12} sm={6}>
                  <Typography variant='title' id='negotiatedOptionals' className={classes.titleHead} >
                    OPCIONAIS NEGOCIADOS
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Grid container justify='flex-end'>
                    <Grid item>
                      {this.props.estadoId === NEGOTIATION_PHASE ?
                        <AdminOptionalsModal newEditButton={true} updateOptionalsDisplayList={this.props.updateOptionalsDisplayList} negOptionals={this.state.negOptionals} reloadNegOptionals={this.reloadOptionalsBySearch.bind(this)} />
                        :
                        null
                      }
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Toolbar>
          </Paper>

          <DialogContent>
            <Grid container>

              <Grid item xs={12} sm={6}>
                <Typography variant='subheading' id='selectNegotiatedOptionals' className={classes.marginSelectOptionals}>
                  Selecionar opcionais:
                </Typography>
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  id='searchOptionals'
                  label=''
                  placeholder='Pesquisar'
                  type='search'
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position='start' className={classes.searchIconMargin}>
                        <SearchIcon />
                      </InputAdornment>
                    )
                  }}
                  className={classes.searchField}
                  value={this.state.searchOptionalsBy}
                  onChange={this.handleSearch}
                />
              </Grid>

              <Grid item xs={12} sm={12}>
                {reloading && <LinearProgress />}
              </Grid>
              {this.renderNegOptionals(this.state.optionalsData)}
            </Grid>
          </DialogContent>

          <Divider />
          <DialogActions disableActionSpacing>
            <Toolbar>
              <Tooltip title='Confirmar' placement='bottom' >
                <Button variant='fab' color='primary' className={classNames(classes.button, classes.buttonSize)} onClick={this.handleCloseOptionals.bind(this)}>
                  <CheckIcon />
                </Button>
              </Tooltip>
            </Toolbar>
          </DialogActions>

        </Dialog>

        <SnackbarAlert openError={this.state.openError} alertMessage={this.state.alertMessage} handleCloseSnackbar={this.handleCloseSnackbar} />

      </span>
    );
  }
}

RUOptionals.propTypes = {
  classes: PropTypes.object.isRequired
};

const mapStateToProps = (state, oSubLotId) => {
  return {
    selectedOptionals: getcheckedOptionalsBySubLotId(state, oSubLotId.subLotId),
    ...state
  }
};

const mapDispatchToProps = dispatch => ({
  updateCheckedOptionalsbySubLot: (nSubLotId, nOptionalId, checked) => dispatch(updateCheckedOptionalsbySubLot(nSubLotId, nOptionalId, checked))
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(RUOptionals));


// WEBPACK FOOTER //
// ./src/components/UsedRentals/UsedRentalsCreation/UsedRentalsEditLots/RUOptionals.js